import searchStyles from "./search-bar.module.css";
import { useState, useEffect } from "preact/hooks";
import { appSettings } from "../../../package.json";


export function SearchBar({ showMobileMenu, instanceId, showExtraSubmitButton = false }) {
  const [searchInput, setSearchInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [hideSuggestions, setHideSuggestions] = useState(true);
  const triggerApiCall = 2;
  const maxNumberOfSuggestions = 5;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const inputId = `autocomplete-input-${instanceId || "default"}`;

  useEffect(() => {
    setIsMobileMenuOpen(showMobileMenu);
    if (showMobileMenu) {
      setHideSuggestions(true);
      setSuggestions([]);
    }
  }, [showMobileMenu]);

  useEffect(() => {
    if (searchInput.length > triggerApiCall && !hideSuggestions) {
      fetch(
        `${globalThis.translations.homeURL}?auto_complete_search_term=${searchInput}`
      )
        .then((data) => data.json())
        .then((data) => {
          if (data.success && data.data.length > 0) {
            //Ensure only unique titles are displayed
            const seen = new Set();
            const unique = data.data.filter(item => {
              if (seen.has(item.title)) return false;
              seen.add(item.title);
              return true;
            });
            setSuggestions(unique.slice(0, maxNumberOfSuggestions));
          }

        })
        .catch((error) => {
          console.error(error, "Unable to get suggestions");
        });
    }

    if (searchInput === "" || isMobileMenuOpen) {
      setHideSuggestions(true);
      setSuggestions([]);
    }
  }, [searchInput]);

  function submit(e) {
    if (e) e.preventDefault();

    window.location.assign(globalThis.translations.homeURL + appSettings.searchPageUrl + searchInput);
  }

  return (
    <form onSubmit={submit} class={`search-form ${searchStyles["form"]}`}>
      <div class={`search-box ${searchStyles["search-box"]}`}>
        <button type="submit" class={searchStyles["button"]}>
          <span class={`material-symbols-outlined ${searchStyles["icon"]}`}>
            search
          </span>
        </button>
        <input
          id={inputId}
          type="search"
          class={searchStyles["input"]}
          value={searchInput}
          autocomplete="off"
          placeholder=" "
          onInput={(e) => {
            setHideSuggestions(false);
            setSearchInput(e.currentTarget.value);
          }}
        />
        <label htmlFor={inputId} class={searchStyles["label"]}>
          {globalThis.translations.autocompleteLabel || "What are you looking for?"}
        </label>
      </div>

      {suggestions.length > 0 && (
        <div class={searchStyles["suggestions-box"]}>
          <div class={`container-md ${searchStyles["container"]}`}>
            <h4 class={searchStyles["heading"]}>{ globalThis.translations.suggestionsLabel }</h4>
            <ul class={searchStyles["suggestions-list"]}>
              {suggestions.map((option) => (
                <li class={searchStyles["suggestion"]} key={option.title}>
                  <button
                    onClick={() => {
                      setSearchInput(option.title).then(() => { submit(); });
                      setHideSuggestions(true);
                      setSuggestions([]);
                    }}
                    class={searchStyles["link"]}
                  >
                    {option.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {showExtraSubmitButton && (
        <div class={`button-wrapper`}>
          <button
            type="submit"
            class={`button`}
          >
            <span class="button-text">{globalThis.translations.extraSubmitButtonLabel || "Search"}</span>
          </button>
        </div>
      )}
    </form>
  );
}
